// top level domain should have a stargate proxy under this path
// see https://developer.atlassian.com/platform/stargate/concepts/domains/
export const GATEWAY_URL = `/gateway/api`;
